import constants from './constants';

const mfaData = mfa => mfa;

export default {
  [constants.GETTER_MFA_DATA]: mfaData
};



// WEBPACK FOOTER //
// ./src/store/modules/mfa/getters.js